import { render } from "./ParserVacancy.vue?vue&type=template&id=491e174e&scoped=true"
import script from "./ParserVacancy.vue?vue&type=script&lang=js"
export * from "./ParserVacancy.vue?vue&type=script&lang=js"

import "./ParserVacancy.vue?vue&type=style&index=0&id=491e174e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-491e174e"]])

export default __exports__